import { usePrismic } from "@/hooks/usePrismic";
import { initializeChatBot } from "@/libs/chatBot";
import { RoutesApp } from "@/Routes";
import { useEffect } from "react";
import { OutOfServiceProvider } from "./OutOfServiceProvider";
import { SpinLoader } from "./SpinLoader";
import { StyleProvider } from "./StyleProvider";

export const App = () => {
  const t = usePrismic();

  useEffect(() => {
    initializeChatBot();
  }, []);

  return (
    <OutOfServiceProvider title={t.home.notFun.h1} subtitle={t.home.notFun.h3}>
      <SpinLoader text={t.home.loading} />
      <StyleProvider>
        <RoutesApp />
      </StyleProvider>
    </OutOfServiceProvider>
  );
};
